import { useVesselLogo } from "./useVesselLogo";

interface Props {
  size?: number;
}

const VesselLogoThumbnail = ({ size = 28 }: Props) => {
  const { logo } = useVesselLogo();

  if (!logo) return null;

  return (
    <img
      src={logo}
      alt="Vessel logo"
      style={{ height: size, maxWidth: size * 3, objectFit: "contain" }}
    />
  );
};

export default VesselLogoThumbnail;
